import * as axios from "axios";
import { notification } from "ant-design-vue";

import { JwtUtil } from "../utils/jwt";

export const JWT_HEADER_NAME = "XAuthorization";

export function redirectToLoginPage() {
  const loginUrl = `${window.location.origin}/login`;
  JwtUtil.clearJwtToken();
  setTimeout(() => {
    window.location.href = loginUrl;
  }, 1000);
}

export function errorHandler(error) {
  const { response } = error;
  if (response) {
    if (response.status === 401) {
      notification.error({
        message: "请求错误",
        description: "当前登录信息已过期，请重新登录",
      });
      redirectToLoginPage();
    } else if (response.data && response.data.message) {
      notification.error({
        message: "请求错误",
        description: response.data.message,
      });
    }
    return Promise.reject(response);
  }
  return Promise.reject(error);
}

axios.defaults.baseURL = window.location.origin;

axios.interceptors.request.use(
  (config) => {
    const token = JwtUtil.getJwtToken();
    if (token) {
      config.headers = {
        ...config.headers,
        [JWT_HEADER_NAME]: `Bearer ${token}`,
      };
    }
    return config;
  },
  (error) => {
    console.log("---req err", error);
    if (error.data) {
      return Promise.reject(error.data);
    }
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(null, errorHandler);

export default axios;
